import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { CargoHostDialogComponent } from '@cargo/components/cargo-host-dialog/cargo-host-dialog.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
	declarations: [
		CargoHostDialogComponent
	],
	imports: [
		CommonModule,
		MatDialogModule,
		SharedModule
	]
})
export class CargoModule { }
